import * as React from 'react';
import Navigation from './Navigation';
import '../../scss/styles.scss';
import 'semantic-ui-css/semantic.min.css';
import Footer from './Footer';
import { Helmet } from 'react-helmet';

class Layout extends React.Component {
  constructor(props) {
    super(props);

    this.state = { environment: '', pageName: '' };

    //debugger;
    // here it was getting the page from props passed into here
  }

  syncMenuWithUrl() {
    // debugger;

    // eslint-disable-next-line
    const pageName = location.pathname.replace(/\/|v2/gi, '');

    // eslint-disable-next-line
    const sectionId = window.location.hash.replace('#', '');

    const topMenuItem = document.getElementById(pageName);
    const subMenuItem = document.getElementById(`${pageName}-${sectionId}`);

    this._resetSubCategory();
    if (topMenuItem) {
      topMenuItem.setAttribute('class', 'active');
    }
    if (subMenuItem) {
      subMenuItem.setAttribute('class', 'sub-category active');
    } else {
      // select the 'overview' which is the first submenu item:
      // const subMenuItems = document.querySelectorAll(`#${pageName} .sub-category`);
      const subMenuItems = document.querySelectorAll(
        `[data-subsection="${pageName}"]`
      );

      if (subMenuItems && subMenuItems.length) {
        subMenuItems[0].className = 'sub-category active';
      }
    }
  }

  componentDidMount() {
    //debugger;
    // 1) when we loaded a direct URL, need to update the menu

    this.syncMenuWithUrl();

    // // here attach all event handlers
    // debugger;
    // console.log('mounted');
    if (typeof window !== 'undefined') {
      window.addEventListener(
        'hashchange',
        () => {
          //debugger;
          // fires when clicking history and typing the url manually
          // we need to do the menu
          this.syncMenuWithUrl();
        },
        false
      );

      window.addEventListener(
        'load',
        () => {
          //debugger;
          // console.log("page-load fired");
          this._scrollToActiveSection();
        },
        false
      );

      // purpose of this is to highlight the item in menu as we scroll
      window.addEventListener('scroll', () => {
        //debugger;
        // console.log("page-scroll fired");
        this._handleScroll();
      });
    }

    // eslint-disable-next-line
    const pageName = location.pathname.replace(/\/|v2/gi, '');
    if (this.state.pageName !== pageName) {
      this.setState({ ...this.state, pageName: pageName });
    }

    if (this.props.appLocation) {
      console.log(this.props.appLocation.hostname, this.state);
      switch (this.props.appLocation.hostname) {
        case 'brandguidelines.toyota.co.nz':
          this.setState({ pageName: pageName, environment: 'PROD' });
          console.log('Env: PROD');
          break;
        case 'uattnz.z26.web.core.windows.net':
          this.setState({ pageName: pageName, environment: 'TEST' });
          console.log('Env: TEST');
          break;
        case 'localhost':
          this.setState({ pageName: pageName, environment: 'LOCAL' });
          console.log('Env: LOCAL');
          break;
      }
    }
  }

  _handleScroll() {
    // debugger;

    const isElementXPercentInViewport = (elem, percentVisible) => {
      const rect = elem.getBoundingClientRect(),
        windowHeight =
          window.innerHeight || document.documentElement.clientHeight;
      var result = !(
        Math.floor(
          100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100
        ) < percentVisible ||
        Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) <
        percentVisible
      );
      return result;
    };
    const overviewElem = document.querySelector('.page-header');
    if (
      overviewElem &&
      isElementXPercentInViewport(overviewElem, 50) &&
      overviewElem.id
    ) {
      this._resetSubCategory();
      this._highlightSubmenu(overviewElem.id);
    } else {
      // debugger;
      // 1) need to determine currently active section
      const sections = document.querySelectorAll('section');
      // var sectionId = "";

      const visibleSections = [...sections].filter((s) =>
        isElementXPercentInViewport(s, 10)
      ); // NodeList is not an arraty
      const sectionHeaders = document.querySelectorAll(
        'section .section-header h2'
      );
      const visibleSectionHeaders = [...sectionHeaders].filter((h) =>
        isElementXPercentInViewport(h, 80)
      );
      if (visibleSectionHeaders.length) {
        // debugger;
        this._resetSubCategory();
        this._highlightSubmenu(
          visibleSectionHeaders[0].parentElement.parentElement.parentElement.id
        ); // hacky, relies on nesting structure
        return;
      }

      // debugger;
      if (visibleSections.length) {
        this._resetSubCategory();
        // const subCategory = document.getElementsByClassName('active sub-category');
        // for (var i = subCategory.length - 1; i>=0; i--){
        //     subCategory[i].className = subCategory[i].className.replace('active', '');
        // }

        // highlight the menu
        this._highlightSubmenu(visibleSections[0].id);
      } else {
        if (overviewElem && isElementXPercentInViewport(overviewElem, 5)) {
          this._resetSubCategory();
          if (overviewElem.id) {
            this._highlightSubmenu(overviewElem.id);
          } else {
            this._highlightSubmenu(sections[0].id);
          }
        }
      }
    }

    return;
  }

  getActiveSection() {
    const classesNodeList = document.querySelectorAll('.active-section');
    const activeSections = Array.prototype.slice
      .call(classesNodeList)
      .map((element) => element);
    const activeSection = activeSections[activeSections.length - 1];
    return activeSection;
  }

  _resetSubCategory() {
    // // debugger;
    // const subCategory = document.getElementsByClassName('active sub-category');
    // for (var i = subCategory.length - 1; i>=0; i--){
    //     subCategory[i].className = subCategory[i].className.replace('active', '');
    // }

    const subCategory = document.getElementsByClassName('active sub-category');
    for (var i = subCategory.length - 1; i >= 0; i--) {
      subCategory[i].className = subCategory[i].className.replace('active', '');
    }
  }

  _highlightSubmenu(sectionId) {
    // eslint-disable-next-line
    const pageName = location.pathname.replace(/\/|v2/gi, '');
    const subMenuItem = document.querySelector(
      `.sub-category#${pageName}-${sectionId}`
    );
    //const subMenuItem = document.querySelector(`.sub-category#${sectionId}`);
    if (subMenuItem) {
      subMenuItem.setAttribute('class', 'active sub-category');
    }
    const topMenuItem = document.querySelector(`a#${pageName}`);
    if (topMenuItem) {
      topMenuItem.scrollIntoView();
    }
  }

  _scrollToActiveSection() {
    // the purpose of this is to scroll to active section when the page is loaded with a hash part in the url
    debugger;
    console.log('scroll to active section');

    // eslint-disable-next-line
    const pageName = location.pathname.replace(/\/|v2/gi, '');

    // eslint-disable-next-line
    const hash = window.location.hash.replace('#', '');

    if (!hash) {
      return;
    }

    this._resetSubCategory();

    if (pageName) {
      const topMenuItem = document.getElementById(pageName);
      if (topMenuItem) {
        topMenuItem.setAttribute('class', 'active');
      }
    }

    if (hash && pageName) {
      const subMenuItem = document.getElementById(`${pageName}-${hash}`);
      if (subMenuItem) {
        subMenuItem.setAttribute('class', 'sub-category active');
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll);
  }

  subMenuItemClick(e) {
    // 1) we call preventDefault which means we need to display the section manually:
    e.preventDefault();
    // eslint-disable-next-line
    history.pushState({}, '', e.target.href);
    const clickedMenuItemId = e.target.id; // each submenu must be marked with id attribute
    // eslint-disable-next-line
    const pageName = location.pathname.replace(/\/|v2/gi, '');
    if (pageName && clickedMenuItemId) {
      // TODO: clear all active classes

      this._resetSubCategory();

      // expand the top menu item
      //const parentMenuItem = document.getElementById(pageName);
      // if (parentMenuItem){
      //     parentMenuItem.setAttribute('class', 'active');
      // }

      // const clickedMenuItem = document.getElementById(sectionId);
      // if (clickedMenuItem){
      //     clickedMenuItem.setAttribute('class', 'sub-category active');
      // }

      e.target.setAttribute('class', 'sub-category active');

      const sectionId = clickedMenuItemId.replace(`${pageName}-`, ''); // clickedMenuItemId is id of the menu item clicked, eg photography-product. sectionID is 'product'
      const sectionElem = document.getElementById(sectionId);
      if (sectionElem) {
        sectionElem.scrollIntoView();
      }
    }
  }

  pageTitle = (pageName) => {
    // converting first letter to uppercase
    let title = pageName.charAt(0).toUpperCase() + pageName.slice(1);
    title = title.replace(/-/g, ' ');
    return title;
  };

  render() {
    console.log(this.state);
    return (
      <div className="ui one column grid main-grid">
        <Helmet>
          <title>
            {this.pageTitle(
              convertToTitleCase(this.state.pageName)
            )} | Toyota NZ - Visual Identity System
          </title>
          <meta name="robots" content="noindex"></meta>
          <meta name="googlebot" content="noindex"></meta>
        </Helmet>

        <Navigation
          environment={this.state.environment}
          page={this.props.page}
        />

        <main className={`content ${this.state.pageName}`}>
          {this.props.children}
          <Footer />
        </main>
      </div>
    );
  }
}

function convertToTitleCase(str) {
  if (!str) {
    return ""
  }
  return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

export default Layout;
